import Ustawienia from "./Ustawienia"

export default Ustawienia
